<template>
   <div>
        <CRow>
            <CCol sm="12">
                <CButton v-show="can_reply" @click="collapse = !collapse" color="primary" class="mb-2">
                    ارسال پاسخ
                </CButton>
                <CCollapse :show="collapse" :duration="400">
                    <CCard body-wrapper>
                        <CCardHeader>پاسخ جدید</CCardHeader>
                        <CCardBody>
                            <CRow>
                                <CCol sm="3">
                                    <CTextarea v-model="form.message_text.val" :description="form.message_text.inv" label="پیام" rows="3"
                                        @keyup.enter="access=false" />
                                </CCol>
                                <CCol sm="3">
                                    <CInputFile v-show="$store.state.perms.can_attach_file_in_all_user_conversations ||
                                        $store.state.perms.can_attach_file_in_same_group_user_conversations ||
                                        $store.state.perms.can_attach_file_in_user_conversations"
                                        label="آپلود فایل"
                                        @change="file=$event[0]"
                                    />
                                </CCol>
                            </CRow>
                            <br>
                            <div class="form-group form-actions">
                                <CButton @click="validator();submit()" color="primary"> ارسال</CButton>
                            </div>
                        </CCardBody>
                    </CCard>
                </CCollapse>
            </CCol>
            <CCol sm="12">
                <CCard>
                    <CCardHeader>پیام‌های پشتیبانی</CCardHeader>
                    <CCardBody>
                        <div v-for="(item, index) in items" :key="index">
                            <CRow>
                                <CCol>
                                    <CCard>
                                        <CCardHeader v-if="item.user_id == $store.state.user_id" color="info">{{item.id}} - {{item.user_name}}</CCardHeader>
                                        <CCardHeader v-else color="secondary">{{item.id}} - {{item.user_name}}</CCardHeader>
                                        <!-- <CCardBody v-html="item.message_text"></CCardBody> -->
                                        <CCardBody>
                                            <span v-for="(line, lineNumber) of item.message_text.split('\n')"
                                                :key="lineNumber">
                                                {{line}} <br/>
                                            </span>
                                        </CCardBody>
                                        <CCardFooter>
                                            <div class="flex-container">
                                                <div v-show="item.user_id == $store.state.user_id">
                                                    وضعیت:
                                                    <CBadge :color="get_badge(item.is_read)">
                                                        {{item.is_read}}
                                                    </CBadge>
                                                </div>
                                                <div v-show="item.is_read == 'خوانده نشده'">
                                                    <div v-show="$store.state.perms.can_user_update_last_user_messages_in_conversation" @click="redirect_to(`/support/${$route.params.id}/message/${item.id}`)" v-c-tooltip.hover="'ویرایش'">
                                                        <CIcon name="cilPencil" size="lg"/>
                                                    </div>
                                                </div>
                                                <div v-show="item.is_read == 'خوانده نشده'">
                                                    <div v-show="$store.state.perms.can_user_delete_last_user_messages_in_conversation" @click="delete_modal=true;id=item.id" v-c-tooltip.hover="'حذف'">
                                                        <CIcon name="cilTrash" size="lg"/>
                                                    </div>
                                                </div>
                                                <div v-show="item.attachment_id != 0">
                                                    <div @click="download_modal=true;id=data.item.id" v-c-tooltip.hover="'دانلود'">
                                                        <CIcon name="cilPaperclip" size="lg"/>
                                                    </div>
                                                </div>
                                            </div>
                                        </CCardFooter>
                                    </CCard>
                                </CCol>
                            </CRow>
                        </div>
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
        <CModal
            title="دقت کنید"
            size="sm"
            color="primary"
            :show.sync="download_modal"
            >
            <p>آیا برای دانلود فایل اطمینان دارید؟</p>
            <template #footer>
                <CButton @click="download_modal=false" color="secondary">خیر</CButton>
            <CButton @click="download" color="primary">بله</CButton>
            </template>
        </CModal>
        <CModal
			title="دقت کنید"
			size="sm"
			color="danger"
			:show.sync="delete_modal"
			>
			<p>آبا برای حذف اطمینان دارید؟</p>
			<template #footer>
				<CButton @click="delete_modal=false" color="secondary">خیر</CButton>
				<CButton @click="delete_row" color="danger">بله</CButton>
			</template>
		</CModal>
   </div>
</template>

<script>
import validator from '../mixins'
export default {
    mixins: { validator },
    data() {
        return {
            items: [],
            collapse: false,
            form: {
                message_text: { val: '', inv: '', v: { req: true, max: 2048 } },
            },
            file: '',
            disable: false,
            can_reply: false,
            close_modal: false,
            download_modal: false,
            id: 0,
            access: true,
            delete_modal: false,
        }
    },
    mounted(){
        this.get_support_messages();
    },
    methods: {
        get_badge(status) {
            switch (status) {
                case 'خوانده شده': return 'info';
                case 'خوانده نشده': return 'success';
            }
        },
        get_support_messages(){
            this.axios.get('conversations/'
                + '?id=' + this.$route.params.id)
                .then(res => {
                    this.can_reply = res.data[0].can_reply;
                    res.data[0].conversation_messages.map(val => {
                        val.message_text = String(val.message_text).replaceAll('&lt;br&gt;', '\n')
                        if(val.is_read == false){
                            if(val.user_id != this.$store.state.user_id){
                                this.axios.get('/conversation_messages/?id=' + this.$route.params.id);
                                val.is_read = 'خوانده شده';
                            }
                            val.is_read = 'خوانده نشده';
                        } else{
                            val.is_read = 'خوانده شده';
                        }
                        val.user_name = val.other_user_info.name;
                    });
                    this.items = res.data[0].conversation_messages;
                })
        },
        submit(){
            if(this.access){
                if(this.disable == false){
                    if(this.file != ''){
                        const reader = new FileReader();
                        reader.readAsDataURL(this.file);
                        reader.onload = () => {
                            const data = new FormData();
                            data.set('base64_file', reader.result.split('base64,')[1]);
                            data.set('file_type', reader.result.split(':').pop().split(';')[0]);
                            data.set('file_name', this.file.name);
                            this.$notify({
                                group: 'foo',
                                type: 'success',
                                text: 'فایل در حال آپلود است. لطفا صبور باشید.'
                            });
                            this.axios.post('upload_file/', data)
                                .then(res => {
                                    const data = new FormData();
                                    for (const key in this.form){
                                        data.set(key, String(this.form[key].val).replaceAll('\n', '<br>'));                                  
                                    }
                                    data.set('conversation_id', this.$route.params.id);
                                    data.set('attachment_id', res.data.id);
                                    this.axios.post('conversation_messages/', data)
                                        .then(() => {
                                            this.$notify({
                                                group: 'foo',
                                                type: 'success',
                                                text: 'ارسال با موفقیت انجام شد.'
                                            });
                                            this.get_support_messages();
                                            for (const key in this.form) {
                                                this.form[key].val = '';
                                            }
                                        })
                                        .catch(() => {
                                            this.$notify({
                                                group: 'foo',
                                                type: 'error',
                                                text: 'خطا! لطفا مجددا تلاش کنید.'
                                            });
                                        })
                                })
                                .catch(() => {
                                    this.$notify({
                                        group: 'foo',
                                        type: 'error',
                                        text: 'خطا! لطفا مجددا تلاش کنید.'
                                    });
                                })
                        }
                    } else {
                        const data = new FormData();
                        for (const key in this.form){
                            data.set(key, String(this.form[key].val).replaceAll('\n', '<br>'));                     
                        }
                        data.set('conversation_id', this.$route.params.id);
                        this.axios.post('conversation_messages/', data)
                            .then(() => {
                                this.$notify({
                                    group: 'foo',
                                    type: 'success',
                                    text: 'ارسال با موفقیت انجام شد.'
                                });
                                this.get_support_messages();
                                for (const key in this.form) {
                                    this.form[key].val = '';
                                }
                            })
                            .catch(() => {
                                this.$notify({
                                    group: 'foo',
                                    type: 'error',
                                    text: 'خطا! لطفا مجددا تلاش کنید.'
                                });
                            })
                    }
                }
            }
            this.access = true;
        },
        download(){
            this.$notify({
                group: 'foo',
                type: 'success',
                text: 'فایل در حال دانلود است. لطفا صبور باشید.'
            });
            this.axios.get('conversation_attachments/?id='
                + this.id, {responseType: 'blob'})
                .then(res => {
                    const FileSaver = require('file-saver');
                    FileSaver.saveAs(new Blob([res.data], {type : res.headers['content-type']}));
                    this.download_modal = false;
                })
                .catch(() => {
                    this.$notify({
                        group: 'foo',
                        type: 'error',
                        text: 'خطا! لطفا مجددا تلاش کنید.'
                    });
                    this.download_modal = false;
                })
        },
        delete_row() {
			this.axios.delete('conversation_messages/'
			+ this.id)
			.then(() => {
				this.$notify({
					group: 'foo',
					type: 'success',
					text: 'حذف با موفقیت انجام شد.'
                });
				this.delete_modal = false;
				this.get_support_messages();
			})
			.catch(() => {
				this.$notify({
					group: 'foo',
					type: 'error',
					text: 'خطا! لطفا مجددا تلاش کنید.'
                });
                this.delete_modal = false;
			})
        },
        redirect_to(route) {
            this.$router.push(route);
        },
    },
    beforeCreate() {
        if (this.$store.state.perms.can_view_user_conversations_page == false
            && this.$store.state.verif == false) {
            this.$router.push('/403')
        }
    },
}
</script>
